export default "__VITE_ASSET__CDjhnslm__"